// components/editor/swipe-action.ts
export const SWIPE_THRESHOLD = 96 // px of horizontal travel to commit an action

// How much horizontal travel must dominate vertical travel before a gesture counts
// as a swipe rather than a scroll. Below this ratio the finger is mostly moving up
// or down the page, so the card must yield to scrolling.
export const SWIPE_AXIS_RATIO = 1.5

export type SwipeResult = "approve" | "skip" | "none"

/** Pure map from horizontal drag delta (px, +right) to a review action. */
export function swipeAction(dx: number): SwipeResult {
  if (dx >= SWIPE_THRESHOLD) return "approve"
  if (dx <= -SWIPE_THRESHOLD) return "skip"
  return "none"
}

/**
 * Dominant-axis lock. A gesture only counts as a horizontal swipe once its
 * horizontal travel clearly exceeds its vertical travel (`|dx| > |dy| * RATIO`).
 * Otherwise the finger is scrolling the page and the card must ignore it. A pure
 * vertical drag (`dx === 0`) is never a swipe; a pure horizontal drag always is.
 */
export function isHorizontalSwipe(dx: number, dy: number): boolean {
  return Math.abs(dx) > Math.abs(dy) * SWIPE_AXIS_RATIO
}
